const imageBanner = [
    {
        image: require('./banner-2.png'),
        imageTitle: require('../LOGO-Text.png'),
        title: "Thu gom từng hạt rác, tô điểm vạn màu xanh",
        desc: "Mỗi địa điểm bạn đánh dấu, là một nhịp cầu lan tỏa yêu thương. Từng bãi rác, từng góc phố – nay được kết nối trên bản đồ chung."
    },
    {
        image: require('./banner-1.webp'),
        // imageTitle: require('../LOGO-Text.png'),
        title: "\"Clean today, green tomorrow!\" \n \"Think green, act green!\"",
        desc: "Hãy cùng nhau hành động – từ những điều nhỏ bé thường ngày, Để mỗi con đường, mỗi dòng sông lại rộn vang tiếng cười xanh mát."
    },
    {
        image: require('./banner-3.png'),
        imageTitle: require('../LOGO-Text.png'),
        title: "Thu gom từng hạt rác, tô điểm vạn màu xanh",
        desc: "Chung tay – ghi nhận – và làm sạch, vì một hành tinh bền vững ngày mai!"
    },
]

export default imageBanner